//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//firebase
import { db } from 'assets/firebase';

//redux
import { connect } from 'react-redux'

// styles
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";

import IconButton from "@material-ui/core/IconButton";

import Parallax from "components/Parallax/Parallax.jsx";
import coverPhoto from "assets/img/resources.jpg"
import Download from "@material-ui/icons/CloudDownload";
//import logo from "assets/img/logo.png"

import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.jsx";

const dashboardRoutes = [];

class SupportMaterialPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      general: [],
      q1: [],
      q2: [],
      q3: [],
      q4: [],
      counselors: []
    }

    db.getSupportMaterial().then(materials => {
      
      var general = [];
      var counselors = [];
      var q1 = [];
      var q2 = [];
      var q3 = [];
      var q4 = [];
      
      for(var i = 0; i < materials.length; i++) {
        if (materials[i].Type === 'activities' || materials[i].Type === 'assessments' || materials[i].Type === 'goals' || materials[i].Type === 'slides')
          counselors.push(materials[i]);
        else if(materials[i].Quarter === 0)
          general.push(materials[i]);
        else if (materials[i].Quarter === 1)
          q1.push(materials[i]);
        else if (materials[i].Quarter === 2)
          q2.push(materials[i]);
        else if (materials[i].Quarter === 3)
          q3.push(materials[i]);
        else if (materials[i].Quarter === 4)
          q4.push(materials[i]);
        
      }

      this.setState({general: general, q1: q1, q2: q2, q3: q3, q4: q4, counselors: counselors});
    });
  }

  download(file) {
    const start = file.URL.lastIndexOf('/') + 1;
    const length = file.URL.indexOf('?') - start;
    var fileName = file.URL.substr(start, length);
    fileName = fileName.substr(12); // getting rid of "downloads%2F"
    
    var url = "https://us-central1-keiki-262db.cloudfunctions.net/downloadMaterial?fileName=" + fileName;

    window.open(url);
  }

  getCategory(type) {
    if(type === 'activities')
      return 'Activities';
    else if(type === 'assessments')
      return 'Assessments';
    else if(type === 'goals')
      return 'Goals';
    else if(type === 'posters')
      return 'Posters';
    else if(type === 'slides')
      return 'Slides';
    else if (type === 'teams')
      return 'TEAM';
    else 
      return 'General';
  }

  render() {
    const { classes, ...rest } = this.props;

    if (!this.props.user) {
      return <Redirect to='/login' />
    } else if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    } 

    return (

      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="All Things EQ"
          links={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "dark"
          }}
          {...rest}
        />
        <Parallax filter image={coverPhoto}>
          <div className={classes.container} style={{position: "static", marginBottom:"89px"}}>
            <GridContainer style={{textAlign: "center"}}>
              <GridItem xs={12} sm={12} md={12}>
                <br />
              </GridItem>
              <br /><br />
            </GridContainer>
          </div>
        </Parallax>
        
        <div className={classNames(classes.main, classes.mainRaisedHigh)} style={{backgroundColor:"#efefef", marginTop:"-269px", marginLeft:"10px", marginRight:"10px", borderRadius:"6px", minHeight:"500px"}}>
          <div className={classes.container}>
            
            <div className={classes.section} >

                <GridContainer>
                    <GridItem xs={12}>
                      <br />
                      <h3 style={{color:"black"}} classes={[classes.title, classes.black]}>Support Material</h3>

                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        
                      <h4 style={{color:"#DF8F43", marginTop:"34px"}}>General</h4>
                      <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{width:"54px", paddingRight:"3px"}}>

                                    </TableCell>
                                    <TableCell style={{paddingRight:"3px"}}>
                                        Title
                                    </TableCell>
                                    <TableCell style={{paddingRight:"3px"}}>
                                        Category
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {this.state.general.map(value => (
                                <TableRow key={value.id} className={classes.tableRow}>
                                    <TableCell className={classes.tableActions} style={{width:"54px", paddingRight:"3px"}} >
                                        <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                            <IconButton aria-label="Download" className={classes.tableActionButton} >
                                                <Download className={ classes.tableActionButtonIcon + " " + classes.close } onClick={() => this.download(value)} />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                        {value.Name}
                                    </TableCell>
                                    <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                        {this.getCategory(value.Type)}
                                    </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                      </Table>

                      <h4 style={{color:"#DF8F43", marginTop:"34px"}}>Counselor's Corner</h4>
                      <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{width:"54px", paddingRight:"3px"}}>

                                    </TableCell>
                                    <TableCell style={{paddingRight:"3px"}}>
                                        Title
                                    </TableCell>
                                    <TableCell style={{paddingRight:"3px"}}>
                                        Category
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {this.state.counselors.map(value => (
                                <TableRow key={value.id} className={classes.tableRow}>
                                    <TableCell className={classes.tableActions} style={{width:"54px", paddingRight:"3px"}} >
                                        <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                            <IconButton aria-label="Download" className={classes.tableActionButton} >
                                                <Download className={ classes.tableActionButtonIcon + " " + classes.close } onClick={() => this.download(value)} />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                        {value.Name}
                                    </TableCell>
                                    <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                        {this.getCategory(value.Type)}
                                    </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                      </Table>

                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}></GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                      <h4 style={{color:"#DF8F43", marginTop:"34px"}}>Q1</h4>
                      <Table className={classes.table}>
                        <TableHead>
                          <TableRow>
                              <TableCell style={{width:"54px", paddingRight:"3px"}}>

                              </TableCell>
                              <TableCell style={{paddingRight:"3px"}}>
                                  Title
                              </TableCell>
                              <TableCell style={{paddingRight:"3px"}}>
                                  Category
                              </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.q1.map(value => (
                          <TableRow key={value.id} className={classes.tableRow} style={{paddingRight:"3px"}}>
                              <TableCell className={classes.tableActions} style={{width:"54px"}} >
                                  <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                      <IconButton aria-label="Download" className={classes.tableActionButton} >
                                          <Download className={ classes.tableActionButtonIcon + " " + classes.close } onClick={() => this.download(value)} />
                                      </IconButton>
                                  </Tooltip>
                              </TableCell>
                              <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                  {value.Name}
                              </TableCell>
                              <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                  {this.getCategory(value.Type)}
                              </TableCell>
                          </TableRow>
                          ))}
                          </TableBody>
                      </Table>
                      
                      <h4 style={{color:"#DF8F43", marginTop:"34px"}}>Q2</h4>
                      <Table className={classes.table} >
                        <TableHead>
                          <TableRow>
                              <TableCell style={{width:"54px", paddingRight:"3px"}}>

                              </TableCell>
                              <TableCell style={{paddingRight:"3px"}}>
                                  Title
                              </TableCell>
                              <TableCell style={{paddingRight:"3px"}}>
                                  Category
                              </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.q2.map(value => (
                          <TableRow key={value.id} className={classes.tableRow} style={{paddingRight:"3px"}}>
                              <TableCell className={classes.tableActions} style={{width:"54px"}} >
                                  <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                      <IconButton aria-label="Download" className={classes.tableActionButton} >
                                          <Download className={ classes.tableActionButtonIcon + " " + classes.close } onClick={() => this.download(value)} />
                                      </IconButton>
                                  </Tooltip>
                              </TableCell>
                              <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                  {value.Name}
                              </TableCell>
                              <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                  {this.getCategory(value.Type)}
                              </TableCell>
                          </TableRow>
                          ))}
                          </TableBody>
                      </Table>
                      
                      <h4 style={{color:"#DF8F43", marginTop:"34px"}}>Q3</h4>
                      <Table className={classes.table} >
                        <TableHead>
                          <TableRow>
                              <TableCell style={{width:"54px", paddingRight:"3px"}}>

                              </TableCell>
                              <TableCell style={{paddingRight:"3px"}}>
                                  Title
                              </TableCell>
                              <TableCell style={{paddingRight:"3px"}}>
                                  Category
                              </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.q3.map(value => (
                          <TableRow key={value.id} className={classes.tableRow} style={{paddingRight:"3px"}}>
                              <TableCell className={classes.tableActions} style={{width:"54px"}} >
                                  <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                      <IconButton aria-label="Download" className={classes.tableActionButton} >
                                          <Download className={ classes.tableActionButtonIcon + " " + classes.close } onClick={() => this.download(value)} />
                                      </IconButton>
                                  </Tooltip>
                              </TableCell>
                              <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                  {value.Name}
                              </TableCell>
                              <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                  {this.getCategory(value.Type)}
                              </TableCell>
                          </TableRow>
                          ))}
                          </TableBody>
                      </Table>
                      
                      <h4 style={{color:"#DF8F43", marginTop:"34px"}}>Q4</h4>
                      <Table className={classes.table} >
                        <TableHead>
                          <TableRow>
                              <TableCell style={{width:"54px", paddingRight:"3px"}}>

                              </TableCell>
                              <TableCell style={{paddingRight:"3px"}}>
                                  Title
                              </TableCell>
                              <TableCell style={{paddingRight:"3px"}}>
                                  Category
                              </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.q4.map(value => (
                          <TableRow key={value.id} className={classes.tableRow} style={{paddingRight:"3px"}}>
                              <TableCell className={classes.tableActions} style={{width:"54px"}} >
                                  <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                      <IconButton aria-label="Download" className={classes.tableActionButton} >
                                          <Download className={ classes.tableActionButtonIcon + " " + classes.close } onClick={() => this.download(value)} />
                                      </IconButton>
                                  </Tooltip>
                              </TableCell>
                              <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                  {value.Name}
                              </TableCell>
                              <TableCell className={classes.tableCell} style={{paddingRight:"3px"}}>
                                  {this.getCategory(value.Type)}
                              </TableCell>
                          </TableRow>
                          ))}
                          </TableBody>
                      </Table>
                        
                    </GridItem>
                    <GridItem xs={12}>
                      <br /><br />
                      <div style={{fontSize:"13px",textAlign:"center", color:"#545454"}}>
                          These files are intended for use with member schools only.
                      </div>
                      <br /><br />
                    </GridItem>
                </GridContainer>

            </div>
          </div>
        </div>

        <Footer content={
            <div>
              <div className={classes.left}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://app.allthingseq.com/"
                      className={classes.block}
                    >
                      All Things E.Q.
                    </a>
                  </ListItem>
                  
                </List>
              </div>
              <div className={classes.right} style={{fontSize:"12px", marginRight:"23px"}}>
                &copy; {1900 + new Date().getYear()}{" "}
                AVA School Solutions
              </div>
            </div>
          }/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}
SupportMaterialPage = connect(mapStateToProps)(SupportMaterialPage);
export default withStyles(landingPageStyle)(SupportMaterialPage);


// WEBPACK FOOTER //
// ./src/views/SupportMaterialPage/SupportMaterialPage.jsx